/** localforage key for IPersonSignInResponse values (PersonStore) */
export const SIGN_IN_RESPONSE = 'sign_in_response';

export const STORE_CHAT_HTML = 'store_chat_html';
export const STORE_CHAT_RAW = 'store_chat_raw';

export const SELECTED_MICROPHONE = 'selected_microphone';
export const SHOW_INCOMING_CALL = 'show_incoming_call';

export const SELECTED_SPEAKER = 'selected_speaker';
export const SELECTED_RING_DEVICE = 'selected_ringing_speaker';

export const WEB_NOTIFICATIONS_ENABLED = 'web_notifs_enabled';
export const WEB_NOTIFICATION_ACTION_TAKEN = 'web_notif_action_taken';

export const ACTIVITY_LIST_ITEMS_COLLAPSED = 'activity_list_items_collapsed';

export const ACTIVE_CALL = 'active_call';
export const RECENT_CALLS = 'recent_calls';

export const SOFTPHONE_DIMENSIONS_POSITION = 'softphone_dimensions_position';

export const MESSAGE_CREATED_PUSHER_LOGS = 'message_created_pusher_logs';

export const DISMISSED_DESKTOP_NOTIFICATIONS_BANNER =
  'DISMISSED_DESKTOP_NOTIFICATIONS_BANNER';

/**
 * Softphone Coordination Legacy/New
 * LocalStorage key for new softphone preference.
 * Used to enable/disable the new Softphone v2 (beta) instead of legacy softphone.
 */
export const IS_NEW_SOFTPHONE_ENABLED = 'isNewSoftphoneEnabled';

export const CONVERSATIONS_LIST_FILTER = 'conversation_list_filter';

/** Preferred pixel width of the conversations list panel (per user). */
export const CONVERSATIONS_PANEL_WIDTH = 'conversations_panel_width';
